import * as React from 'react';
import { H3, H5, RectangleButton } from '@shared/ui-components';
import { Styled } from './styled';


export const CrashPage: React.SFC = () => {
  const reload = (React as any).useCallback(() => {
    window.location.reload();
  }, []);
  return (
    <Styled.Container>
      <Styled.Img>
        <img src='https://takeoff.kreo.net/static/img/bug.png' />
      </Styled.Img>
      <H3>Oops.. An unexpected error occurred</H3>
      <H5>Our team is already running to fix it</H5>
      <Styled.ContentContainer>
        <RectangleButton
          mood={'secondary'}
          onClick={reload}
          text={'Go Back'}
          width={180}
          height={60}
        />
      </Styled.ContentContainer>
    </Styled.Container>
  );
};
